import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';

export interface CartType {
    channel: string,
    token: string,
}

export interface MeType {
    firstName: string;
    lastName: string;
    login: string;
    email: string;
    carts: CartType[];
    isPromoter: boolean;
}

class MeRepository extends BaseRepositoryClass implements RepositoryType {
    get() {
        return this
            .requester
            .get<MeType>('me');
    }
}

export default MeRepository;
